import { PermissionT } from "../types";

export const sunnovaDesignTeam = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "sunnova_design_team");
  return !!p;
};

export default sunnovaDesignTeam;
